export const maxImageFileSize = 5242880
export const maxImageDimension = 8000
export const supportedMimeTypes = ['image/png', 'image/jpeg', 'image/gif']
export const env = {
  CONTROL: 'control',
  DESTINATION: 'destination'
}
export type EnvTypes = typeof env.CONTROL | typeof env.DESTINATION
